import { Project } from './../../../interfaces/project';
import { Mediaclip } from './../../../interfaces/mediaclip';
import { Component, Input, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { MatAccordionTogglePosition, MatExpansionPanel } from '@angular/material/expansion';

@Component({
	selector: 'bb-collapsible',
	templateUrl: './bb-collapsible.component.html',
	styleUrls: ['./bb-collapsible.component.scss']
})

export class BbCollapsibleComponent implements OnInit {
	@Input() title: string;
	@Input() entity: Mediaclip | Project;
	@Input() description: string;
	@Input() togglePosition: MatAccordionTogglePosition = 'after';
	@Input() hideShadow = false;
	@Input() suffixText? = false;
	@Input() theme?: 'blue' | 'uui' | 'dark';
	@Input() startOpen = false;
	@Input() previewText = '';
	@Output() opened = new EventEmitter();
	@Output() closed = new EventEmitter();

	@ViewChild(MatExpansionPanel) expansionPanelElement: MatExpansionPanel;

	constructor() {	}

	ngOnInit(): void {
		if (this.startOpen) {
			setTimeout(() => {
				this.open();
			}, 50);
		}
	}

	onOpened() {
		this.opened.emit();
	}

	onClosed() {
		this.closed.emit();
	}

	public close(): void {
		this.expansionPanelElement.close();
	}

	public open(): void {
		this.expansionPanelElement.open();
	}

	get isOpen() {
		return this.expansionPanelElement?.expanded;
	}
}
